import React, { useCallback, useEffect, useState } from "react";
import { useAuthContext } from "../../context/auth";
import useCountListDown from "../../hooks/useCountListDown";
import { getMinute } from "../../utils/getMinute";
import dayjs from "dayjs";
import CircularProgress from "../CircularProgress";
import cn from "../../utils/cn";

function Part({ isPart1 }: { isPart1: boolean }) {
  const {
    circuitProgram,
    startTime,
    sendSetStep,
    step,
    emitter,
    did,
    sendCurrentIndex,
  } = useAuthContext();

  const part = isPart1 ? circuitProgram?.part1 : circuitProgram?.part2;
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const timeTable =
    Array(part?.repeatCount)
      .fill(
        part?.movements.flatMap((_, index) => [
          getMinute(part?.time),
          getMinute(
            part?.movements.length - 1 === index
              ? part?.lastSetRestTime
              : part?.restTime
          ),
        ])
      )
      .flat() ?? [];
  const { count, start, currentIndex, stop } = useCountListDown(
    timeTable,
    useCallback(() => {
      sendSetStep(step + 1);
      sendCurrentIndex(0);
    }, [step, sendSetStep, sendCurrentIndex]),
    true
  );

  const currentMovementIndex = Math.floor(currentIndex / 2 / 3);
  const isReversed = did === "L6" && (part?.movements ?? []).length > 3;
  const movements = isReversed
    ? part?.movements.slice(3, 6).reverse()
    : part?.movements.slice(0, 3);

  useEffect(() => {
    setTimeout(() => {
      start();
      videoRef.current?.play();
    }, startTime.current - dayjs().valueOf());

    emitter.current.on("resume", (startTime) => {
      setTimeout(() => {
        start();
        console.log("resume");
        videoRef.current?.play();
      }, startTime - dayjs().valueOf());
    });
    emitter.current.on("pause", (startTime) => {
      setTimeout(() => {
        stop();
        console.log("pause");
        videoRef.current?.pause();
      }, startTime - dayjs().valueOf());
    });
    return () => {
      emitter.current.off("resume");
      emitter.current.off("pause");
    };
  }, []);

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex w-full pl-[70px] pr-[40px] justify-between items-center bg-bg h-[300px]">
        <p className="text-[64px] font-bold text-white">
          Part {isPart1 ? 1 : 2}
        </p>
        <div className="w-[270px]">
          <CircularProgress
            maxValue={timeTable[currentIndex] ?? 0}
            value={count}
            color={currentIndex % 2 === 0 ? undefined : "#FF5757"}
          />
        </div>
      </div>
      {movements?.map((movement, index) => (
        <div
          className="flex-1 flex border-b border-border relative"
          key={index}
        >
          <div className="flex justify-center items-center bg-bg min-w-[160px] max-w-[160px]">
            <h1 className="text-[96px] font-bold gradient-text">
              {isReversed ? 6 - index : index + 1}
            </h1>
          </div>
          <div className="w-full h-full relative">
            {movement.direction !== "X" && (
              <div
                className={cn(
                  "absolute top-[30px]",
                  movement.direction === "L" ? "left-[30px]" : "right-[30px]"
                )}
              >
                <p className="text-[96px] font-medium text-black">
                  {movement.direction}
                </p>
              </div>
            )}
            <video
              className="w-full h-full object-contain"
              ref={videoRef}
              loop
              muted
              key={index}
            >
              <source src={movement.video} type="video/mp4" />
            </video>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Part;
